import React from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticModal from 'components/v2/modal';
import LaneRateAudits from './LaneRateAudits';

export default ({ show, rate, onHide, type }) => {
  const { t } = useTranslation();

  return (
    <CargomaticModal
      dataTestId="CargomaticModal-7eea41c3"
      style={{ top: '15%' }}
      dialogClassName="rounded-xl border-2 border-green-cm w-full"
      showHeader={false}
      show={show}
      onHide={onHide}
      body={
        <div data-testid="div-8d216754" className="relative">
          <h2 data-testid="h2-31e528f5" className="text-xl bold m-0 mb-5">{t('AUDIT_TRAIL')}</h2>
          <div data-testid="div-a5fff0c5" className="flex-auto">
            <LaneRateAudits rate={rate} type={type} />
          </div>
          <button
            data-testid="button-55b87c33"
            onClick={onHide}
            className="absolute  bottom-2 right-4 button button-green">
            {t('CLOSE').toUpperCase()}
          </button>
        </div>
      } />
  );
};
